import { makeAutoObservable, runInAction } from 'mobx';
import EmailContentService, { INotificationDescription } from '../../../services/api/email-content-service';
import { rootContainer, TYPE } from '../../../services/container/root';

class EmailContentdescriptionStore {
	private _categories: INotificationDescription[] = [];

	constructor() {
		makeAutoObservable(this);
	}

	private get emailContentService(): EmailContentService {
		return rootContainer.get<EmailContentService>(TYPE.EmailContentService);
	}

	async load() {
		const catigoriesDescription = await this.emailContentService.getVariablesAndEventsDescription();
		runInAction(() => {
			this._categories = catigoriesDescription;
		});
	}

	public get categories(): INotificationDescription[] {
		return this._categories;
	}
}

export default new EmailContentdescriptionStore();
